export default {
    main: {
        首页: 'HomePage',
        订单生成中: 'Order generating',
        请稍候: 'Please wait...',
        安全支付: 'Secure Payment',
        订单号: 'معرف الطلب',
        金额: 'كمية',
        支付提示: 'نصائح',
        请在: 'من فضلك في ',
        秒内: ' ثواني ',
        完成: 'ينهي ',
        支付: 'قسط ',
        超时会自动: 'سيتم إيقاف المهلة تلقائيًا ',
        取消: 'يلغي ',
        生成中请稍候: 'توليد',
        剩余时间: 'الوقت المتبقي',
        订单已失效: 'Order expired',
        订单已失效Memo: 'Please place an order again or wait for the payment to arrive !',
        订单异常: 'Order Abnormality',
        发生错误: 'An error occurred',
        订单生成失败: 'Order generation failed',
        暂无可用的订单: 'No orders available',
        订单: ' طلب ',
        已支付: ' لقد تم دفع ',
        已超时: ' لقد انتهت مهلة ال ',
        生成失败: ' جيل فاشل ',
        已支付Memo: 'تم تأكيد دفع طلبك بنجاح. يُرجى إغلاق هذه الصفحة وتأكيد استلام المبلغ.',
        已超时Memo: 'انتهت مهلة دفع طلبك. يُرجى إغلاق هذه الصفحة وتقديم طلبك مجددًا.',
        生成失败Memo: 'فشل إنشاء طلبك. يُرجى إغلاق هذه الصفحة وتقديم الطلب مجددًا.',
    }
}
